<template>
  <!-- 品牌介绍 -->
  <div class="content insuranceCompanyInstructions">
    <Form ref="formInline" :model="formData" class="page-form less" :label-width="100">
      <FormItem label="内容" prop="content" class="full">
        <div v-html="formData.content"></div>
      </FormItem>
      <FormItem class="full" label="保司简介" prop="intro">
        <Row v-for="(item, index) in formData.intro" :key="index">
          <Row
            ><Col
              ><a @click="toUrl(item.path)">{{ item.fileName }}</a></Col
            ></Row
          >
        </Row>
      </FormItem>
    </Form>
  </div>
</template>
  <script>
export default {
  data: () => ({
    formData: {
      id: '',
      companyId: '',
      content: '',
      intro: []
    }
  }),
  created() {},
  methods: {
    init(item = {}) {
      this.$refs.formInline && this.$refs.formInline.resetFields();
      if (item.id) {
        this.formData.companyId = item.id;
        this.getDetail();
      }
    },
    //基本信息
    getDetail() {
      this.$http({
        url: `/buz/insuranceCompany/info/detail`,
        type: 'GET',
        data: {
          type: '3',
          companyId: this.formData.companyId
        }
      }).then(res => {
        if (res.data) {
          try {
            res.data.intro = JSON.parse(res.data.intro || '[]');
          } catch (error) {}
          this.formData = res.data;
        }
      });
    },

    toUrl(url) {
      window.open(url);
    }
  }
};
</script>
  <style lang='scss' scoped>
@import './insuranceCompanyNews';
</style>